import type { SVGProps } from "react";

/**
 * call-outgoing-filled, phone
 * @category Communication
 */
export default function IconCallOutgoingFilled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9.91699 6.86777L9.42226 5.18567C9.17191 4.3345 8.39074 3.75 7.50352 3.75H7.00236H5.72195C4.62914 3.75 3.72593 4.63017 3.84161 5.71684C4.08189 7.97389 4.79191 10.1738 5.93438 12.143C7.35756 14.596 9.40402 16.6424 11.857 18.0656C13.8365 19.2141 16.0078 19.8922 18.2539 20.1409C19.3518 20.2625 20.25 19.3546 20.25 18.25V16.4965C20.25 15.6093 19.6655 14.8281 18.8143 14.5777L17.1322 14.083C16.4366 13.8784 15.6849 14.0783 15.1827 14.6014C14.5934 15.2152 13.6645 15.3863 12.95 14.9242C11.4005 13.9222 10.0778 12.5995 9.07581 11.05C8.61373 10.3355 8.78479 9.40661 9.39863 8.81732C9.92173 8.31514 10.1216 7.56343 9.91699 6.86777Z'
        fill='currentColor'
      />
      <path
        d='M15.75 3.75H20.25V8.25M14.75 9.25L19.7516 4.24839'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
